/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { OnboardingStepWizard } from '../OnboardingStepWizard';
import { Button } from '../Button';
import ProfileCard from '../FreelancerPortfolio/ProfileCard';
import WorkExperiencesCard from '../FreelancerPortfolio/WorkExperienceCard';
import LanguagesKnowledgeCard from '../FreelancerPortfolio/LanguagesKnowledgeCard';
import SkillsCard from '../FreelancerPortfolio/SkillsCard';
import TaglineCard from '../FreelancerPortfolio/TaglineCard';
import ProjectTypeCard from '../FreelancerPortfolio/ProjectTypeCard/ProjectTypeCard';

const FreelancerOnboardingStep = ({
  isNextEnabled,
  formValues,
  handleGoToAnswer,
  currentOnboardingStep,
  currentOnboardingSteps,
  handlePrevStep,
  handleNextStep,
  handleAddAnotherExperience,
  handleInputChange,
  handleCheckboxChange,
  handleOtherOptionsInputChange,
  handleSelectCard,
}) => {
  const currentOverviewStep = 'freelancer_onboarding';

  const cardInfoIndex = currentOnboardingSteps[
    currentOverviewStep
  ].freelancerSteps.findIndex(elem => elem.key === currentOnboardingStep);

  const portfolioStepInfo =
    currentOnboardingSteps[currentOverviewStep].freelancerSteps[cardInfoIndex];

  const stepComponents = {
    edit_profile: () => (
      <ProfileCard {...formValues} handleInputChange={handleInputChange} />
    ),
    experiences: () => (
      <WorkExperiencesCard
        {...formValues}
        handleInputChange={handleInputChange}
        handleAddAnotherExperience={handleAddAnotherExperience}
      />
    ),
    skills: () => (
      <SkillsCard
        {...formValues}
        stepInfo={portfolioStepInfo}
        handleCheckboxChange={handleCheckboxChange}
        handleOtherOptionsInputChange={handleOtherOptionsInputChange}
      />
    ),
    languages: () => (
      <LanguagesKnowledgeCard
        {...formValues}
        handleInputChange={handleInputChange}
      />
    ),
    tagline: () => (
      <TaglineCard {...formValues} handleInputChange={handleInputChange} />
    ),
    project_type: () => (
      <ProjectTypeCard
        {...formValues}
        stepInfo={portfolioStepInfo}
        handleSelectCard={handleSelectCard}
      />
    ),
  };

  return (
    <div className="main portfolio-step">
      <OnboardingStepWizard
        handleGoToAnswer={handleGoToAnswer}
        currentOverviewStep={currentOverviewStep}
        currentOverviewSteps={[currentOverviewStep]}
        currentOnboardingStep={currentOnboardingStep}
        currentOnboardingSteps={
          currentOnboardingSteps[currentOverviewStep].freelancerSteps
        }
        selectedValue={portfolioStepInfo.selectedValue}
        isNextEnabled={isNextEnabled}
      />

      <div className="onboarding-step container py-10">
        <div className="row">
          <div className="col-12">
            <h4 className="t-20 text-gray text-center mb-4">
              {portfolioStepInfo.hero}
            </h4>
            <p className="t-15 text-center mb-8">
              {portfolioStepInfo.description}
            </p>
            <div className="row">{stepComponents[portfolioStepInfo.key]()}</div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col d-flex justify-content-center flex-column flex-lg-row">
            <div className="mr-lg-3">
              <Button
                rounded
                bordered
                block
                title="PREVIOUS"
                className="btn btn-rounded btn-lg btn-outline-primary mt-lg-5 mx-lg-2 t-13 px-6"
                onClick={handlePrevStep}
              />
            </div>
            <div className="ml-lg-3">
              <Button
                rounded
                block
                title="NEXT"
                className="btn btn-rounded btn-lg btn-primary mt-3 mt-lg-5 mx-lg-2 t-13 px-9"
                onClick={handleNextStep}
                disabled={!isNextEnabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FreelancerOnboardingStep.propTypes = {
  isNextEnabled: PropTypes.bool,
  handleGoToAnswer: PropTypes.func,
  currentOnboardingStep: PropTypes.string,
  currentOnboardingSteps: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  handleNextStep: PropTypes.func,
  handlePrevStep: PropTypes.func,
  handleAddAnotherExperience: PropTypes.func,
  formValues: PropTypes.object,
  handleInputChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  handleOtherOptionsInputChange: PropTypes.func,
  handleSelectCard: PropTypes.func,
};

export default FreelancerOnboardingStep;



// WEBPACK FOOTER //
// ./src/components/FreelancerOnboardingStep/FreelancerOnboardingStep.js